"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPassageFeedback = void 0;
const base_1 = require("./base");
const const_1 = require("./const");
const sendPassageFeedback = (passageId, text, extraInfo) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(`${const_1.BASE_PATH}/event/passage-feedback`, Object.assign({ passageId, customerText: text }, extraInfo), true);
});
exports.sendPassageFeedback = sendPassageFeedback;
